import { render } from "./AdminControlViewPermissions.vue?vue&type=template&id=2aab7736"
import script from "./AdminControlViewPermissions.ts?vue&type=script&lang=js"
export * from "./AdminControlViewPermissions.ts?vue&type=script&lang=js"

import "./AdminControlViewPermissions.vue?vue&type=style&index=0&id=2aab7736&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__